<template>
  <div>
    <h1 class="page-header">Product</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button color="info" outline @click="$router.push({ name: 'product-create' })">
              Add New
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input v-model="search" placeholder="Search" style="width: 300px;" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td>{{ record.product_name_kh }}</td>
          <td>{{ record.product_name_en }}</td>
          <td>{{ record.category.category_name_en }}</td>
          <td>{{ record.inventory_type }}</td>
          <td>{{ record.unit_measure.uom_name_en }}</td>
          <td>{{ record.unit_measure.uom_qty }}</td>
          <td>{{ record.saling_price }}</td>
          <td>{{ record.reorder_min }}</td>
          <td>{{ record.reorder_max }}</td>
          <td class="text-center">
            <router-link
              :to="{
                name: 'product-edit',
                params: { id: record.product_id }
              }"
              title="edit"
              class="mr-2"
            >
              <i class="fas fa-edit"></i>
            </router-link>

            <a href="#" title="delete" class="text-danger" @click="destroy(record.product_id)">
              <i class="fas fa-trash"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'product',
  data() {
    return {
      loading: false,
      columns: [
        { name: 'product name kh' },
        { name: 'product name en' },
        { name: 'category' },
        { name: 'inventory type' },
        { name: 'uom name' },
        { name: 'uom qty' },
        { name: 'saling price' },
        { name: 're-order min' },
        { name: 're-order max' },
        { name: 'Actions', style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('inventory/product', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.inventory.product.search
      },
      set(newValue) {
        this.$store.commit('inventory/product/SET_SEARCH', newValue)
        this.$store.commit('inventory/product/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('inventory/product/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    async destroy(product_id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('inventory/product/destroy', product_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'product-create') {
      this.$store.commit('inventory/product/RESET_STATE')
    }
    next()
  }
}
</script>
